/**
 * Generato automaticamente.
 * framework-cmp-domande
 */

export type EnumRichiestaDTOStatoPreventivi =
  (typeof EnumRichiestaDTOStatoPreventivi)[keyof typeof EnumRichiestaDTOStatoPreventivi];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const EnumRichiestaDTOStatoPreventivi = {
  DA_ACCETTARE: 'DA_ACCETTARE',
  DA_PAGARE: 'DA_PAGARE',
  PAGATO: 'PAGATO',
  NESSUNO: 'NESSUNO',
} as const;
